<template>
    <div class="con">
        <banComponent :img="info.img" :text0="info.text0" :text1="info.text1"></banComponent>
        <div class="main">
            <div class="mainCon">
                <p class="title">{{newsInfo.TITLE}}</p>
                <p class="time"><i class="iconfont shijian"></i><span>{{newsInfo.SHOWTIME}}</span></p>
                <div class="htmlCon" v-html="newsInfo.CONTENT">

                </div>
            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import  banComponent from '../components/tbanner'
    import footComponent from '../components/foot'
    import {getNewsInfo} from '../util/lang'
    export default {
        name: "newsInfo",
        data(){
            return{
                info:{
                    img:require('../assets/culture/ban.png'),
                    text0:'领导关怀',
                    text1:'亲切的关怀，巨大的鼓舞'
                },
                newsInfo:{}
            }
        },
        components:{banComponent,footComponent},
        mounted(){
            if( this.$i18n.locale === 'en'){
                this.info={
                    img:require('../assets/culture/ban.png'),
                    text0:'LEADERSHIP CARE',
                    text1:'Kind caring, great inspiration'
                }
            }
            this.getNewsInfo(this.$route.query.id)
        },
        methods:{
            getNewsInfo(id){
                this.$nextTick(()=>{
                    const url = `${getNewsInfo( 'zh-CN',id)}`
                    this.$axios.get(url).then(res => {
                        res.data.SHOWTIME=res.data.SHOWTIME.substring(0,11)
                        this.newsInfo=res.data
                    })
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    .main{
        background-color: #F7F7F7;
        width:100%;
        padding: 60px 0;
        .mainCon{
            width:1280px;
            margin: 0 auto;
            background-color: white;
            padding: 20px 30px;
            .title{
                font-size: 25px;
                font-weight: bold;
                text-align: center;
                padding-bottom: 20px;
            }
            .time{
                text-align: center;
                border-top: 1px solid #e5e5e5;
                padding: 20px 0;
                span{
                    padding-left: 10px;
                    font-size: 14px;
                    color:#999;
                }
            }
            .htmlCon{
                width:100%;
                margin: 60px auto;
                font-size: 14px;
                line-height: 30px;
                overflow: hidden;
            }
        }
    }
    @media screen and (max-width:1280px){
        .main{
            .mainCon{
                width:1200px;
            }
        }
    }
    @media screen and (max-width:1279px){
        .main{
            .mainCon{
                width:90%;
                margin-left: 2.5%;
                padding: 20px 2.5%;
                .title{
                    font-size: 16px;
                    line-height: 30px;
                }
                .htmlCon{
                    margin: 0px auto;
                }
            }
        }
    }
}
</style>
<style scoped>
    @media screen and (max-width:450px){
        .htmlCon >>> p img{
            width:100%;
            object-fit: cover;
        }
    }

</style>